<div class="hp-wrap">
  <h3 class="hp-heading">{{ heading }}</h3>

  <div class="harmony-preview">
    <div class="hp-head">
      <!-- The swatch IS the colour picker: click it to choose a base colour. -->
      <input class="hp-swatch"
             type="color"
             [value]="swatch"
             (input)="onPicker($any($event.target).value)"
             aria-label="Pick a base color">
      <div class="hp-input-wrap">
        <label class="hp-label" for="hp-hex">Pick a Color</label>
        <input id="hp-hex"
               class="hp-text"
               type="text"
               autocomplete="off"
               spellcheck="false"
               maxlength="7"
               inputmode="latin"
               [value]="text"
               (input)="onText($any($event.target).value)"
               (keydown)="onKey($event)"
               aria-label="Base hex color code">
      </div>
    </div>

    <div class="hp-groups" [class.hp-groups-wheeled]="wheels">
      <div class="hp-group" *ngFor="let group of groups" [class.hp-group-wheeled]="wheels">
        <div class="hp-group-main">
          <div class="hp-group-head">
            <span class="hp-group-label">{{ group.label }}</span>
            <span class="hp-group-desc">{{ group.description }}</span>
          </div>
          <div class="hp-chip">
            <span class="hp-seg" *ngFor="let color of group.colors" [style.background]="color"></span>
          </div>
          <div class="hp-hexes">
            <span class="hp-hex" *ngFor="let color of group.colors">{{ color }}</span>
          </div>
        </div>

        <!-- Each shown scheme gets its own little wheel showing the geometry: a line
             across for complementary, a fan for split / analogous, a triangle for
             triadic, a cross for tetradic. The visible groups are already filtered
             by [only], so every shown group gets a wheel. -->
        <app-color-wheel class="hp-group-wheel" *ngIf="wheels"
                         [harmony]="true" [colors]="group.colors" [base]="hex"
                         [shape]="( group.key === 'tetradic' || group.key === 'triadic' ) ? 'polygon' : 'fan'" heading=""></app-color-wheel>
      </div>
    </div>
  </div>
</div>
